import { ClientApplication, UpdaterSettings } from '@numeo/types-core'
import axios from 'axios'

class UpdaterSettingsApi {
    // For global updater settings
    async updateSettings(projectName: string, settings: UpdaterSettings): Promise<ClientApplication> {
        const response = await axios.put(`/updater/settings/${projectName}`, settings)
        return response.data.application
    }

    /** Explicit disconnect of one internal Telegram group (avoids race with full-settings overwrite). */
    async deleteInternalTelegramGroup(projectName: string, chatId: string): Promise<ClientApplication> {
        const response = await axios.delete(`/updater/settings/${projectName}/notification/internal-telegram-groups/${encodeURIComponent(chatId)}`)
        return response.data.application
    }

    /** Upload an image for a notification template (max 1MB, JPEG/PNG only). Returns the GCS URL. */
    async uploadNotificationTemplateImage(file: File): Promise<string> {
        const formData = new FormData()
        formData.append('image', file)
        const response = await axios.post('/updater/loads/notification-template-image', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
        return response.data.data.imageUrl
    }
}

export const updaterSettingsApi = new UpdaterSettingsApi()
